import { useEffect, useState } from 'react';
import { WifiOff } from 'lucide-react';

/**
 * Persistent toast pinned bottom-center when the browser reports it's
 * offline. SSE will auto-reconnect once we're back online — this just lets
 * the operator know stale data they're looking at is, in fact, stale.
 */
export function OfflineToast() {
  const [online, setOnline] = useState<boolean>(typeof navigator !== 'undefined' ? navigator.onLine : true);

  useEffect(() => {
    const goOnline = () => setOnline(true);
    const goOffline = () => setOnline(false);
    window.addEventListener('online', goOnline);
    window.addEventListener('offline', goOffline);
    return () => {
      window.removeEventListener('online', goOnline);
      window.removeEventListener('offline', goOffline);
    };
  }, []);

  if (online) return null;

  return (
    <div
      role="status"
      className="fixed left-1/2 -translate-x-1/2 bottom-24 lg:bottom-6 z-50 inline-flex items-center gap-2 px-3 py-2 rounded-full text-xs font-semibold border border-kam-red/30 bg-kam-red-soft text-kam-red shadow-lg backdrop-blur"
    >
      <WifiOff size={14} />
      <span>Offline — showing cached data. Reconnecting…</span>
    </div>
  );
}
